<template>
    <div class="HotProducts">
        <div class="left_btn" @click="cut()">
            <img src="../../public/img/09m/home/left.png" alt="" srcset="">
        </div>
        <div class="right_btn" @click="add()">
            <img src="../../public/img/09m/home/right.png" alt="" srcset="">
        </div>
        <div class="HotProducts-swiper">
            <div class="swiper-wrapper" >
                <div class="swiper-slide pro_item" v-for="(item, index) in productInfo" :key="index">
                    <div class="product_card">
                        <div class="card_img">
                            <img :src="baseUrl + 'img/09m/hot_product/'+ item.src" alt="" srcset="">
                        </div>
                        <div class="card_bottom">
                            <div class="card_bottom_line"></div>
                            <div class="card_bottom_text">{{$t(item.text)}}</div>
                            <div class="card_bottom_btn">{{$t('详细了解')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper'
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            productInfo:[
                {
                    src:'一次性PP + PE微孔 (SF) 连体服.jpg',
                    text:'63g透气膜(PP+PE)贴条防护服',
                    url:'/productClass_info?productId=1&classId=1'
                },
                {
                    src:'25g一次性隔离衣.jpg',
                    text:'25g一次性隔离衣',
                    url:'/productClass_info?productId=13&classId=3'
                },
                {
                    src:'一次性工作服.jpg',
                    text:'一次性工作服',
                    url:'/productClass_info?productId=7&classId=1'
                },
                {
                    src:'一次性微孔 (SF) 工作服 56 型隔离衣.jpg',
                    text:'一次性防护服',
                    url:'/productClass_info?productId=8&classId=1'
                },
                {
                    src:'一次性隔离连体服.jpg',
                    text:'82g覆膜(SPP+PE)贴条防护服',
                    url:'/productClass_info?productId=3&classId=1'
                },
                {
                    src:'一次性鞋套.jpg',
                    text:'一次性鞋套',
                    url:'/productClass_info?productId=28&classId=10'
                },
                {
                    src:'定制蓝色面具耳挂 ⅱ型一次性医用口罩.jpg',
                    text:'一次性防护口罩',
                    url:'/productClass_info?productId=15&classId=4'
                },
            ]
        }
    },
    methods:{
        add(){
            this.mySwiper.slideNext();  
        },
        cut(){
            this.mySwiper.slidePrev();
        },
        openInfo(url){
            // this.$router.push(url)
        }
    },
    mounted(){
        let _this = this
        this.mySwiper = new Swiper('.HotProducts-swiper',{
            loop:false,
            grabCursor: true,
            slidesPerView: 'auto',   //设置slider容器能够同时显示的slides数量
            paginationClickable: true,
            autoplay: true,
            on:{
                transitionEnd: function(swiper){
                    // console.log(swiper.realIndex)
                },
                click:function(swiper){
                    _this.$router.push(_this.productInfo[swiper.clickedIndex%7].url)
                }
            },
        });
        this.timer = setInterval(()=>{
           this.mySwiper.slideNext();
        },8000)
    },
    destroyed(){
        clearInterval(this.mySwiper)
    }
}
</script>
<style scope lang="less">
.HotProducts{
    width: 100vw;
    height: 30vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .left_btn{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(8vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
            height: 60%;
            transform: translateX(-10%);
        }
    }
    .right_btn{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(-8vw,-50%);
        width: 3.5vw;
        height: 3.5vw;
        border-radius: 50%;
        cursor: pointer;
        background-color: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            height: 60%;
            transform: translateX(10%);
        }
    }
    .HotProducts-swiper{
        width: 73%;
        height: 30vw;
        overflow: hidden;
        position: relative;
        .swiper-slide{
            width: 25%;
            height: 100%;
                   
        }
        .pro_item{
            display: flex;
            align-items: center;
            justify-content: center;
            .product_card{
                width: 96%;
                height: 98%;
                background-color: #F7F7F7;
                cursor: pointer;  
                transition: 0.3s all ease-in-out;
                &:hover{
                    background-color: #ffffff;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
                }
                .card_img{
                    width: 100%;
                    position: relative;
                    height: 74%;
                    img{
                        width: 100%;
                        height: 100%;
                        display:block;
                        min-width: 100%;
                        min-height: 100%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform:translate(-50%,-50%);
                        object-fit: cover
                    }
                }
                .card_bottom{
                    width: 100%;
                    height: 22%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    .card_bottom_line{
                        width: 88%;
                        height: 2px;
                        background-image: linear-gradient(45deg,#009D40,#007CA9);
                        margin: 0 auto;
                    }
                    .card_bottom_text{
                        width: 88%;
                        font-size: 0.8rem;
                        text-align: center;
                        margin: 0 auto;
                        color: #565656;
                        font-weight: bold;
                    }
                    .card_bottom_btn{
                        height: 30%;
                        width: 60%;
                        display: flex;
                        color: #F7F7F7;
                        font-size: 0.7rem;
                        cursor: pointer;
                        align-items: center;
                        transition: 0.1s ease-in-out all;
                        &:hover{
                            transform: scale(1.05);
                        }

                        justify-content: center;
                        background-image: linear-gradient(90deg,#009D40,#007CA9);                      
                    }
                }
            }
            
        }
    }
}
</style>
<i18n>
{
  "en": {
    "详细了解":"More",
    "63g透气膜(PP+PE)贴条防护服":"63g microporous(PP+PE) with tape coveralls",
    "25g一次性隔离衣":"25g disposable isolation gown",
    "一次性工作服":"38gsm PP lab coat",
    "一次性防护服":"Disposable Protective Clothing",
    "82g覆膜(SPP+PE)贴条防护服":"82g (SPP+PE) coveralls with tape",
    "一次性防护口罩":"Disposable face mask"
  },
  "zh": {
      "详细了解":"详细了解",
      "63g透气膜(PP+PE)贴条防护服":"63g透气膜(PP+PE)贴条防护服",
      "25g一次性隔离衣":"25g一次性隔离衣",
      "一次性工作服":"一次性工作服",
      "一次性防护服":"一次性防护服",
      "82g覆膜(SPP+PE)贴条防护服":"82g覆膜(SPP+PE)贴条防护服",
        "一次性防护口罩":"一次性防护口罩"
    }
}
</i18n>